import { defineComponent as _defineComponent } from 'vue'
import SignaturePad, { PointGroup } from 'signature_pad'
import { onMounted, ref } from 'vue'
import { useFormField } from '@/components/vision/next/forms/useFormAdapter'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignaturePad',
  props: {
    height: { default: 200 },
    width: { default: 435 },
    required: { type: Boolean }
  },
  emits: ["input", "clear"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'input', signature: File)
  (event: 'clear')
}), expose: any, slots: any, attrs: any }) {

const props = __props as { height: number, width: number, required?: boolean }



let pad: SignaturePad
const canvas = ref<HTMLCanvasElement | null>(null)
const signature = ref<PointGroup[]>([])

const {
  allErrorMessages: errorMessages,
  hasErrorMessages,
  runValidation,
} = useFormField({
  value: signature,
  required: props.required,
})



onMounted(() => {
  if (!canvas.value) return

  pad = new SignaturePad(canvas.value)
  pad.addEventListener('endStroke', () => {
    signature.value = pad.toData()
    runValidation()
    exportSignature()
  })
})

function exportSignature() {
  canvas.value?.toBlob((blob) => {
    if (!blob) return
    const file = new File([blob], 'signature.png', { type: 'image/png' })
    emit('input', file)
  })
}

function clear() {
  pad.clear()
  signature.value = pad.toData()
  runValidation()
  emit('clear')
}

function undo() {
  const data = pad.toData()

  if (data.length < 2) {
    clear()
  } else {
    data.pop()
    signature.value = pad.toData()
    pad.fromData(data)
    exportSignature()
  }
}

return { __sfc: true,props, pad, canvas, signature, errorMessages, hasErrorMessages, runValidation, emit, exportSignature, clear, undo }
}

})